import { render, staticRenderFns } from "./unverified_from_free_pay.vue?vue&type=template&id=0bcbde26&"
import script from "./unverified_from_free_pay.vue?vue&type=script&lang=js&"
export * from "./unverified_from_free_pay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports